<div
    class="flex justify-between items-start bg-white sm:p-6 px-2 py-4 rounded-2xl border border-[#E7EAF0] gap-2 cursor-pointer"
    [routerLink]="['/profile', peopleSignal().id]"
    (click)="onPersonClick()">
    <div class="flex gap-3 max-w-[65%]">
        @if (peopleSignal().photo !== ' ' && peopleSignal().photo) {
            <img
                class="h-12 w-12 rounded-full object-cover border border-[#E7EAF0]"
                alt="Profile"
                [src]="peopleSignal().photo" />
        } @else {
            <div
                class="h-12 w-12 rounded-full object-cover border border-[#E7EAF0] bg-white text-[#4F66FF] flex items-center justify-center font-bold text-[1.2rem]">
                {{ peopleSignal().name.charAt(0) | uppercase }}
            </div>
        }
        <div class="flex flex-col gap-[5px] justify-center">
            <p class="text-[#0A0A0A] font-medium">
                {{ peopleSignal().name }}

                @if (isFollowRequest) {
                    <span class="text-[#717182]">wants to follow you.</span>
                }
            </p>
            @if (isJoinRequest) {
                <p class="mt-2 text-[0.875rem] text-[#717182]">
                    Requested {{ peopleSignal().createdAt | date: 'dd/MM/yyyy' }}
                </p>
            }
        </div>
    </div>
    @if (isJoinRequest) {
        <div class="flex gap-2">
            <button
                type="button"
                class="border-button p-2 px-3 gap-2 flex items-center bg-[#00A63E] hover:bg-[#00A63E99]"
                (click)="
                    $event.stopPropagation(); isFollowRequest ? acceptFollowRequest() : approveMemberJoinRequest()
                ">
                <img class="w-4 h-4" alt="Approve" src="/assets/images/shared/white-tick-icon.svg" />
                <p>{{ isFollowRequest ? 'Accept' : 'Approve' }}</p>
            </button>
            <button
                type="button"
                class="white-border-button p-2 px-3 gap-2 flex items-center text-[#D4183D]"
                (click)="
                    $event.stopPropagation();
                    isFollowRequest ? rejectFollowRequest() : openRejectMemberJoinRequestPopup()
                ">
                <img class="w-4 h-4" alt="Reject" src="/assets/images/shared/cross-red-icon.svg" />
                <p>Reject</p>
            </button>
        </div>
    }
    @if (isGroupMember) {
        <div class="flex items-center gap-2">
            <div
                class="w-fit flex space-x-1 px-3 py-1 rounded-full border text-[0.8rem] font-medium"
                [ngClass]="
                    isOwnGroup()
                        ? 'bg-[#4F66FF] text-white'
                        : peopleSignal().role === GroupRoleTypeEnum.Moderator
                          ? 'border-[#2B7FFF33] bg-[#4F66FF0D] text-[#4F66FF]'
                          : peopleSignal().role === GroupRoleTypeEnum.Member
                            ? 'border-[#E7EAF0] bg-[#ECECF0] text-[#717182]'
                            : peopleSignal().role === GroupRoleTypeEnum.Admin
                              ? 'border-[#FF690033] bg-[#FF69001A] text-[#CA3500]'
                              : ''
                ">
                @if (
                    [GroupRoleTypeEnum.Moderator, GroupRoleTypeEnum.Member, GroupRoleTypeEnum.Admin].includes(
                        peopleSignal().role
                    )
                ) {
                    <img
                        class="h-4 w-auto"
                        alt="PostType"
                        [src]="
                            isOwnGroup()
                                ? '/assets/images/shared/crown-white-icon.svg'
                                : peopleSignal().role === GroupRoleTypeEnum.Moderator
                                  ? '/assets/images/shared/shield-icon.svg'
                                  : peopleSignal().role === GroupRoleTypeEnum.Member
                                    ? '/assets/images/shared/people-icon.svg'
                                    : '/assets/images/shared/shield-red-icon.svg'
                        " />
                }
                <p>
                    {{
                        isOwnGroup()
                            ? getGroupRoleTypeLabel(GroupRoleTypeEnum.Owner)
                            : getGroupRoleTypeLabel(peopleSignal().role)
                    }}
                </p>
            </div>
            @if (isAdminModerator && !isOwnGroup()) {
                <div class="relative">
                    <div
                        class="sm:block hidden h-4 w-4 cursor-pointer rotate-90"
                        [matMenuTriggerFor]="dropdownMenu"
                        (click)="$event.stopPropagation()">
                        <img src="/assets/images/shared/more-options-grey-icon.svg" alt="MoreOptions" />
                    </div>

                    <mat-menu #dropdownMenu="matMenu">
                        @for (action of getRoleActions(); track $index) {
                            <div
                                class="flex items-center gap-2 p-2 cursor-pointer hover:bg-[#f5f6f8]"
                                (click)="action.click()">
                                <img class="w-auto h-4" [alt]="action.alt" [src]="action.icon" />
                                <p class="text-[0.875rem] text-[#0A0A0A]">{{ action.text }}</p>
                            </div>
                        }
                        <div
                            class="flex items-center gap-2 p-2 border-t border-[#E7EAF0] cursor-pointer hover:bg-[#f5f6f8]"
                            (click)="openRemoveMemberPopup()">
                            <img class="w-auto h-4" alt="Remove" src="/assets/images/shared/delete-icon.svg" />
                            <p class="text-[0.875rem] text-[#D4183D]">Remove from Group</p>
                        </div>
                    </mat-menu>
                </div>
            }
        </div>
    }
</div>
